export const environment = {
  production: false,
  notchFrontendServiceUrl: "https://app.notchcx.io",
  chatServiceUrl: "https://chat.notchcx.io",
  commandCenterUrl: "https://commandcenter.notchcx.io",
  keysUrl: "https://keys.notchcx.io",
  commsServiceUrl: "https://comms.notchcx.io",
  twitterServiceUrl: "https://twitter.notchcx.io",
  filesServiceUrl: "https://files.notchcx.io",
  notificationsServiceUrl: "https://notifications.notchcx.io",
  salesClientServiceUrl: "https://sales.notchcx.io",
  targetServiceUrl: "https://target.notchcx.io",
  whatsAppBot: "https://wsapp.notchcx.io",
  mailServiceUrl: "https://mail.notchcx.io",
  facebookServiceUrl: "https://facebook.notchcx.io",
  instagramServiceUrl: "https://instagram.notchcx.io",
  customFormUrl: "https://api.notchcx.io/forms",
  productsAndService: "https://atbstore.blob.core.windows.net/samples/sample-products.csv?sp=r&st=2024-10-31T12:46:43Z&se=2028-12-31T20:46:43Z&spr=https&sv=2022-11-02&sr=b&sig=mS6384k00l0rPjg2mTRUIWab1eSSZFQjxmmm%2B856mKk%3D",
  templateAndSequenceUrl: "https://tempseq.notchcx.io",
  paystackKey: "pk_live_16a1302a8de5f28fc326762451137bf2c85e459c",
  DownloadUrl: "https://sales.notchcx.io/samples",
  apiUrl: "https://api.notchcx.io",
  localUrl: "http://10.10.100.79:",
  localUrlJava: "http://10.10.100.79:",
  localUrlNode: "http://localhost:",
  socketUrl: "https://notch-chat-bot.herokuapp.com",
  emailDomain: "@applive.notchcx.io",
  baseUrl: "https://app.notchcx.io",
  notchWebsite: "https://app.notchcx.io",
  notchAppURL: "https://app.notchcx.io",
  notchPDFConverter: "https://files.notchcx.io/attachments/pdf/conversion",
  notchTenantInfo: { id: 17022, name: "NotchCRM" },
  emailAlternative: ",notanemailaddressatall.com",
};

export const Office365OuthSettings = {
  appId: "6c63c897-fadd-494b-a31e-0e9482e7c731",
  authority: "https://login.microsoftonline.com/common/",
  redirectUri: "http://localhost:4200/clients/outlook-callback",
  scopes: ["offline_access", "Mail.ReadWrite", "Mail.Send", "User.Read"],
  validateAuthority: false,
};

export const PathfixConfig = {
  public_key: "46909325-A1AB-4CB8-87EB-BF8C5BC3E464",
};

export const GmailRedirectUri = `https://app.notchcx.io/clients/google-callback`;
export const FacebookSettings = {
  clientId: "3048240628766460",
  redirectUri: "https://app.notchcx.io/settings/ticket-inbound",
  scope: `pages_show_list pages_manage_metadata pages_messaging pages_manage_engagement pages_read_engagement pages_read_user_content pages_manage_posts instagram_basic business_management instagram_manage_messages`,
};
